import { render, staticRenderFns } from "./psd.vue?vue&type=template&id=ab8d3470&scoped=true&"
import script from "./psd.vue?vue&type=script&lang=js&"
export * from "./psd.vue?vue&type=script&lang=js&"
import style0 from "./psd.vue?vue&type=style&index=0&id=ab8d3470&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8d3470",
  null
  
)

export default component.exports